module.exports = __webpack_public_path__ + "img/page-bg.a05db405.png";